import React from 'react';
import {
  Edit,
  SimpleForm,
  BooleanInput,
  TextInput,
  maxLength,
  required,
  SaveButton,
  DeleteButton,
  Toolbar,
} from "react-admin";

import { CachedProvincesInput } from "../common/CachedProvincesInput/CachedProvincesInput";

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <div
      style={{
        display: "flex",
        gap: "10px",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <SaveButton />
      <DeleteButton />
    </div>
  </Toolbar>
);

export const TechnicalServiceEdit = (props) => {
    // Transform the data to ensure province is set correctly for the backend
    const transform = (data) => {
        return {
            ...data,
            province: { id: data.provinceId }
        };
    };

    return (
        <Edit 
            {...props}
            transform={transform}
            actions={null}
        >
            <SimpleForm redirect="/services" toolbar={<CustomToolbar />}>
                <TextInput 
                    source="name" 
                    label="Nombre" 
                    validate={[required(), maxLength(100)]} 
                />
                <CachedProvincesInput 
                    source="provinceId"
                    label="Provincia"
                    validate={[required()]}
                />
                <TextInput 
                    source="city" 
                    label="Ciudad" 
                    validate={[required(), maxLength(100)]} 
                />
                <TextInput 
                    source="address" 
                    label="Dirección" 
                    validate={[required(), maxLength(100)]} 
                />
                <TextInput 
                    source="phone" 
                    label="Teléfono" 
                    validate={[required(), maxLength(100)]} 
                />
                <BooleanInput 
                    source="active" 
                    label="Activo" 
                />
            </SimpleForm>
        </Edit>
    );
};
